__turbopack_context__.v({
  "buttons": "G1AttW_buttons",
  "callBtn": "G1AttW_callBtn",
  "container": "G1AttW_container",
  "phone": "G1AttW_phone",
  "socButton": "G1AttW_socButton",
  "socIcon": "G1AttW_socIcon",
  "socText": "G1AttW_socText",
});
